import { Box, Chip, ChipProps } from '@mui/material';

import { CustomerJob, CustomerJobStatus } from 'domain/entities/CustomerJob';
import { useTranslationPrefix } from 'infrastructure/translations/i18n';

function getStatusColor(status: CustomerJobStatus): ChipProps['color'] {
  switch (status) {
    case 'submitted':
      return 'default';
    case 'approved':
      return 'primary';
    case 'in_progress':
      return 'warning';
    case 'declined':
      return 'error';
    case 'completed':
      return 'success';
    default:
      return 'default';
  }
}

export const SimpleJobStatusChip = ({ status }: Pick<CustomerJob, 'status'>) => {
  const t = useTranslationPrefix('components.cards.customer_job_status');

  return (
    <Box onClick={(e) => e.stopPropagation()} data-testname="statusChip">
      <Chip label={t(status)} color={getStatusColor(status)} size="small" />
    </Box>
  );
};
